import React from "react";
import { InstantValuationTool } from "components/pages/InstantValuationTool";
import { useAppContext } from "./_app";

export default function PageInstantValuationTool() {
  const {
    products: { IVT },
  } = useAppContext();

  return (
    <>
      <script
        src="https://assets.lead.pro/js/widgets/proval/v1/popup.js"
        defer
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `(function (w, d, n) {
                w[n] =
                  w[n] ||
                  function () {
                    (w[n].q = w[n].q || []).push(arguments)
                  }
              })(window, document, 'LeadPro')
              LeadPro('init', {
                appId: 'ab07510a-2b5a-42e6-a661-12de9a2ba456',
                pageId: '101',
                brandColor: "#ffffff"
              });
            `,
        }}
      />
      <InstantValuationTool data={IVT} />
    </>
  );
}
